import React, { Component } from 'react';

import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { withRouter } from 'react-router';
import { HotKeys } from "react-hotkeys";
import axios from "axios";

import { isCompanyCuit } from "../utils/utils";
import generateValidator from './Validations/generateValidator';
import StatesList from '../containers/StatesContainer.js';
import EmploymentsList from '../containers/EmploymentsContainer.js';
import AssociateTypesList from "../containers/AssociateTypeContainer";
import CustomAlert from '../components/CustomAlert.js';
import asyncValidate from './Validations/asyncValidationsMainForm';
import RenderField from './RenderField';
import SelectField from './SelectField';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner';
import DDJJWarningModal from './DDJJWarningModal';


class MainForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {},
            initialForm: false,
            resources: [
                'email',
                'cuil',
                'name',
                'area_code',
                'number',
                'facto_business_association',
            ]
        };
    }

    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/subscribers/process`, config)
            .then(response => {
                this.setState({
                    resources: response.data.fields,
                    initialForm: false
                });
            }).catch(error => {
                this.setState({
                    initialForm: false
                });
            });
    }

    componentDidUpdate(prevProps, prevState) {
        const { deleteReduxFormField, setValue } = this.props;
        const { resources } = this.state;
        if (prevProps.cuil_value !== this.props.cuil_value) {
            if (!isCompanyCuit(this.props.cuil_value)) {
                deleteReduxFormField('facto_business_association');
            }
        }

        if (resources.length > 0) {
            const hasNotEmploymentIdField = resources.filter( f => f === 'employment_id').length === 0;
            const hasNotStateIdField = resources.filter( f => f === 'state_id').length === 0;
            if (hasNotEmploymentIdField) {
                setValue('employment_id', 12);
            }
            if (hasNotStateIdField) {
                setValue('state_id', 12);
            }
        }

    }

    getEmail = () => {
        return (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="email" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('email') ? 'hidden' : 'email'} label="Correo Electrónico" showSuccess={true} />
                </div>
            </div>
        );
    }

    checkField = (field) => {
        return this.state.resources.includes(field);
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        const initialForm = this.state.initialForm;

        let email = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="email" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('email') ? 'hidden' : 'email'} label="Correo Electrónico" showSuccess={true} />
                </div>
            </div>
        );

        const document_number = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="document_number" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('document_number') ? 'hidden' : 'number'} label="Número de Documento" />
                </div>
            </div>
        );

        const cuil = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="cuil" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('cuil') ? 'hidden' : 'cuil'} label="Cuit /Cuil" />
                </div>
            </div>
        );

        const name = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="name" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('name') ? 'hidden' : 'text'} label="Nombre o Razón Social" />
                </div>
            </div>
        );

        const gender = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field
                        className="form-control"
                        name="gender"
                        autoComplete="off"
                        component={SelectField}
                        options={[{id: 'm', name: 'Masculino'}, {id: 'f', name: 'Femenino'}]}
                        defaultValue={'Sexo según tu DNI'}
                        label={'Género'}
                        type={this.state.fields.hasOwnProperty('gender') ? 'hidden' : 'select'}
                    />
                </div>
            </div>
        );

        const area_code = (
            <div className="col-md-4 col-lg-4">
                <div className="form-group">
                    <Field className="form-control" name="area_code" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('area_code') ? 'hidden' : 'number'} label="Código de Area" showSuccess={true} />
                </div>
            </div>
        );

        const number = (
            <div className="col-md-8 col-lg-8">
                <div className="form-group">
                    <Field className="form-control" name="number" autoComplete="off" component={RenderField} type={this.state.fields.hasOwnProperty('number') ? 'hidden' : 'number'} label="Número de Celular" showSuccess={true} />
                </div>
            </div>
        );

        let employments = null;
        if (this.checkField('employment_id') || this.state.initialForm){
            employments = <EmploymentsList type={this.state.fields.hasOwnProperty('employment_id') ? 'hidden' : 'select'} />;
        }

        if (!this.checkField('employment_id') || !this.state.initialForm){
            employments = <Field className="form-control" name="employment_id" autoComplete="off" component={RenderField} type="hidden" />;
        }

        let states = null;
        if (this.checkField('state_id') || this.state.initialForm){
            states = <StatesList type={this.state.fields.hasOwnProperty('state_id') ? 'hidden' : 'select'} />;
        }

        let associate_type = null;
        if (this.checkField('associate_type_id')){
            associate_type = <AssociateTypesList type={this.state.fields.hasOwnProperty('associate_type_id') ? 'hidden' : 'select'} />;;
        }

        let facto_business_association = null;
        if (this.checkField('cuil') && this.checkField('facto_business_association')){
            const { cuil_value } = this.props;
            if (isCompanyCuit(cuil_value)) {
                const factoBusinessAssociationOptions = [{id: 1, name: 'Si'},{id: 0, name: 'No'}];
                facto_business_association = (
                    <div className='row'>
                        <div className="col-md-12 col-lg-12">
                            <div className="form-group">
                                <AttributeOptions name="facto_business_association" defaultValue="¿Es Sociedad Simple o de Hecho?" label="¿Es Sociedad Simple o de Hecho?" attributeName='is_facto_business_association' attributeOptions={factoBusinessAssociationOptions}/>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return (
            <HotKeys handlers={{SHOW_SELLER_CODE: this.showCodeField}}>
            {(!this.props.isLoading || !submitting || !error) && <DDJJWarningModal/>}
            <div>
                <form onSubmit={handleSubmit(this.props.addSubscriber)} className='pvc-form'>
                    {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                    {error && <CustomAlert bsStyle="danger" message={error}/>}
                    <div className={this.state.fields.hasOwnProperty('name') && this.state.fields.hasOwnProperty('gender') ? 'row-hidden' : 'row' }>
                        {initialForm ? name : (this.checkField('name') ? name : null)}
                        {initialForm ? gender : (this.checkField('gender') ? gender : null)}
                    </div>
                    <div className={this.state.fields.hasOwnProperty('cuil') ? 'row-hidden' : 'row' }>
                        {initialForm ? cuil : (this.checkField('cuil') ? cuil : null)}
                    </div>
                    {facto_business_association}
                    <div className={this.state.fields.hasOwnProperty('email') && this.state.fields.hasOwnProperty('document_number') ? 'row-hidden' : 'row' }>
                        {initialForm ? email : (this.checkField('email') ? email : null)}
                        {initialForm ? document_number : (this.checkField('document_number') ? document_number : null)}
                    </div>
                    <div className={this.state.fields.hasOwnProperty('area_code') && this.state.fields.hasOwnProperty('number') ? 'row-hidden' : 'row' }>
                        {initialForm ? area_code : (this.checkField('area_code') ? area_code : null)}
                        {initialForm ? number : (this.checkField('number') ? number : null)}
                    </div>
                    <div className={this.state.fields.hasOwnProperty('associate_type_id') ? 'row-hidden' : 'row'}>
                        {associate_type}
                    </div>
                    <div className={this.state.fields.hasOwnProperty('employment_id') && this.state.fields.hasOwnProperty('state_id') ? 'row-hidden' : 'row' }>
                        {employments}
                        {states}
                    </div>
                    <div>
                        <Field className="form-control" name="site" autoComplete="off" component={RenderField} type="hidden" />
                    </div>
                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={submitting}>Iniciar</button>
                </form>
            </div>
            </HotKeys>
        );
    }
}

const selector = formValueSelector('main')

MainForm = connect(
    state => {
        const cuil_value = selector(state, 'cuil')
        return {
            cuil_value,
        }
    }
)(MainForm);
let validate = generateValidator([{name: 'name', required: true}]);

MainForm = reduxForm({
    initialValues: {
        site: ((process.env.PAGE === 'ftyc' && 'Ftyc.ob.info') ||
               (process.env.PAGE === 'fiduciaria' && 'Mendoza Fiduciaria') ||
               (process.env.PAGE === 'fiduciaria_flow_1' && 'Mendoza Fiduciaria - 1SGSRSD') ||
               (process.env.PAGE === 'fiduciaria_flow_2' && 'Mendoza Fiduciaria - 2SGSRSH') ||
               (process.env.PAGE === 'fiduciaria_flow_3' && 'Mendoza Fiduciaria - 3SGSRSJ') ||
               (process.env.PAGE === 'fiduciaria_flow_4' && 'Mendoza Fiduciaria - 4SGSRHJ') ||
               (process.env.PAGE === 'fiduciaria_flow_5' && 'Mendoza Fiduciaria - 5CGSRHJ') ||
               (process.env.PAGE === 'fiduciaria_flow_6' && 'Mendoza Fiduciaria - 6SGCRHJ') ||
               (process.env.PAGE === 'fiduciaria_flow_7' && 'Mendoza Fiduciaria - 7CGCRHJ') ||
               (process.env.PAGE === 'cuyoaval' && 'Cuyo Aval'))
    },
    form: 'main', // a unique name for this form
    asyncValidate,
    validate,
    asyncBlurFields: ['email', 'area_code', 'number']
})(MainForm);

MainForm = withRouter(MainForm);

export default MainForm;



/** WEBPACK FOOTER **
 ** ./src/components/MainForm.js
 **/